<template>

	<div :class="{'multi-types-wrap': true, 'pulse': pulse}">

		<h3 class="multi-types-title" v-html="title" v-if="title" />

		<div class="multi-types">

			<span 
				v-for="(multiType, multiTypeIndex) in multiTypes" 
				:key="'multi-type-'+multiTypeIndex" 
				:class="{'multi-type':true, [multiType.type]: true, selected: isCurrent[multiType.type], small: small}"
				@click="clickType(multiType)"
			><img :src="multiType.logo" v-if="multiType.logo" /><font-awesome-icon :icon="multiType.icon" class="svg" :style="{ color: '#212426' }" v-if="multiType.icon" /><span v-html="multiType.label" /><TickCross :hideCross="true" :pulse="false" class="tick-cross" :small="true" :dark="true" :enabled="isCurrent[multiType.type]" v-if="showTickCross" /></span>

		</div>

	</div>

</template>

<script>
import TickCross from './TickCross.vue'
export default {
	name: 'ProjectSetupTypes',
	components: {
		TickCross
	},
	props: {
		multiTypes: {
			type: Array
		},
		current: {
			type: [Array,String]
		},
		type: {
			type: String
		},
		title: {
			type: String,
			default: ''
		},
		small: {
			type: Boolean,
			default: false
		},
		showTickCross: {
			type: Boolean,
			default: true
		},
		single: {
			type: Boolean,
			default: false
		},
		pulse: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			//
		}
	},
	computed: {
		isCurrent () {

			let current = {};

			this.multiTypes.forEach(function ( multiType ) {
				
				current[multiType.type] = Array.isArray( this.current ) ? this.current.indexOf(multiType.type) >= 0 : multiType.type === this.current;

			}.bind(this));

			return current;

		}
	},
	methods: {

		clickType (multiType) {

			this.$emit( 'clicked', { type: this.type, info: multiType } );

		}

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';

@keyframes borderPulse {
  0% {
    border-color: fade(@formDefaultColour, 50%);
  }
  50% {
    border-color: @formDefaultColour;
  }
  100% {
    border-color: fade(@formDefaultColour, 50%);
  }
}

.multi-types-title {

	font-size: 16px;
	margin: 10px 0 5px;

}

.multi-types {

	text-align: center;

	.multi-type {

		display: inline-block;
		cursor: pointer;
		text-align: center;
		color: #fff;
		.rounded(5px);
		padding: 12px 14px 8px;
		.trans;
		width: 130px;
		margin: 10px 20px 20px;
		border: 2px solid fade( @darkContrast, 50% );
		position: relative;

		&.small {

			width: 90px;

		}

		span {

			display: block;
			text-align: center;
			margin-top: 4px;
			.opacity(0.6);
			.trans;

		}

		.tick-cross {

			position: absolute;
			right: 5px;
			top: 4px;

		}

		img, .svg {

			height: 18px;
			width: auto;
			.opacity(0.6);
			.trans;

		}

		&.selected, &:hover {

			img, .svg, span {

				.opacity(1);

			}

		}

		&.selected {

			border-color: @formDefaultColour;

		}

	}

}

.pulse {
	.multi-types {
		.multi-type {
			animation: borderPulse 1.5s ease-in-out infinite;
		}
	}
}
@media screen and (min-width: 540px) {

	.multi-types {

		text-align: left;

		.multi-type {

			display: inline-block;
			margin: 0 20px 10px 0;
			width: 220px;

			img, .svg {

				height: 34px;

			}

			&:last-child {

				margin-right: 0;

			}

		}

	}

}
@media screen and (min-width: 600px) {

	.multi-types {

		.multi-type {

			width: 200px;

			img, .svg {

				height: 30px;

			}

			&.small {

				width: 100px;

			}

		}

	}

}
</style>